// Auto-generated by vite-plugin-themes — do not edit
import type { ThemeManifest } from '@/types/site-config';

export const themes: ThemeManifest[] = [
  {
    "name": "arctic",
    "displayName": "Arctic",
    "description": "Frozen landscapes with cyan ice and aurora effects",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#00ace5",
      "background": "#f4fcff",
      "foreground": "#132139"
    },
    "hasEffects": true
  },
  {
    "name": "cyberpunk",
    "displayName": "Cyberpunk",
    "description": "Neon colors and glitch aesthetics with hot pink and cyan",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#c3228d",
      "background": "#faf9fa",
      "foreground": "#482659"
    },
    "hasEffects": true
  },
  {
    "name": "forest",
    "displayName": "Forest",
    "description": "Earth tones and natural palette with earthy greens and golden accents",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#2d9e53",
      "background": "#f1f7f1",
      "foreground": "#13391f"
    },
    "hasEffects": true
  },
  {
    "name": "monochrome",
    "displayName": "Monochrome",
    "description": "Clean, minimal monochrome palette with off-white and slate tones",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#3c83f5",
      "background": "#f7f9fb",
      "foreground": "#334156"
    },
    "hasEffects": false
  },
  {
    "name": "ocean",
    "displayName": "Ocean",
    "description": "Deep blues and aquatic palette with aqua and teal accents",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#2280c3",
      "background": "#e1edf3",
      "foreground": "#143251"
    },
    "hasEffects": true
  },
  {
    "name": "sakura",
    "displayName": "Sakura",
    "description": "Cherry blossom spring with soft pink and jade green accents",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#e05169",
      "background": "#fbf9f7",
      "foreground": "#471e2c"
    },
    "hasEffects": false
  },
  {
    "name": "sunset",
    "displayName": "Sunset",
    "description": "Desert warmth with orange, pink, and purple gradient skies",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#f86b06",
      "background": "#f9f2ea",
      "foreground": "#56270f"
    },
    "hasEffects": false
  },
  {
    "name": "synthwave",
    "displayName": "Synthwave",
    "description": "Outrun 80s retro-futurism with neon magenta and cyan",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#da0b95",
      "background": "#f1e9f5",
      "foreground": "#3e0f56"
    },
    "hasEffects": false
  },
  {
    "name": "vaporwave",
    "displayName": "Vaporwave",
    "description": "Retro-futuristic aesthetics with pink and cyan neon",
    "author": "Clint Ecker",
    "preview": {
      "primary": "#f20c7f",
      "background": "#f2eef6",
      "foreground": "#321451"
    },
    "hasEffects": false
  }
];

export const themeNames = ['arctic', 'cyberpunk', 'forest', 'monochrome', 'ocean', 'sakura', 'sunset', 'synthwave', 'vaporwave'] as const;

export type ThemeName = (typeof themeNames)[number];
